import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import FilterWordsProfileSource from 'sources/FilterWordsProfileSource';

/** Fetch filter word profiles for the department admin page. */
class FilterWordsProfileActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchAll'));
  }
  fetchAll() {
    return dispatch => {
      dispatch();
      return FilterWordsProfileSource.fetchAll().then(this.fetchAllSuccess, this.fetchAllError);
    };
  }
}

export default alt.createActions(FilterWordsProfileActions);
